<template>
  <v-main>
    <v-container fluid>
      <v-stepper
        v-model="e1"
        class="unitCreateDialog"
      >
      <v-col cols="12">
        <v-btn class="mr-2" fab x-small color="#6c5dd4" dark @click="$router.back()">
            <v-icon size="15" dark> mdi-arrow-left </v-icon> </v-btn>Edit Company
      </v-col>
        <v-stepper-header elevation="0">
          <v-stepper-step color="#6c5dd4" editable :complete="e1 > 1" step="1">
            Company Basic Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step color="#6c5dd4" editable :complete="e1 > 2" step="2">
            Company Location
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="py-2 px-1" >
            <v-card class="mb-12" elevation="0">
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <span class="text-h6"> Enter a basic details </span>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Company Name * </label>
                    <vs-input
                      primary
                      v-model="Editform.name"
                      placeholder="Enter a company name"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-account"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.name ? errors.name : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Email * </label>
                    <vs-input
                      primary
                      v-model="Editform.email"
                      placeholder="Enter a email *"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-email"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.email ? errors.email : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption">Mobile Number * </label>
                    <vs-input
                      primary
                      v-model="Editform.phone"
                      placeholder="Enter a mobile no."
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-phone"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.phone ? errors.phone : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption"
                      >Contact Person Number *
                    </label>
                    <vs-input
                      primary
                      v-model="Editform.contact_person"
                      placeholder="Enter a contact person number."
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-card-account-phone"></i>
                      </template>

                      <template #message-danger>
                        {{
                          errors && errors.contact_person
                            ? errors.contact_person
                            : ""
                        }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col cols="12">
                    <span class="text-h6">Add Address</span>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption"
                      >Enter Address 1 *
                    </label>
                    <vs-input
                      primary
                      v-model="Editform.address_1"
                      placeholder="Enter a address 1"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-map-marker-multiple"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.address_1 ? errors.address_1 : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="" class="text-caption"
                      >Enter Address 2 (optional) *
                    </label>
                    <vs-input
                      primary
                      v-model="Editform.address_2"
                      placeholder="Enter a address 2"
                      icon-after
                      block
                    >
                      <template #icon>
                        <i class="mdi mdi-map-marker-multiple"></i>
                      </template>

                      <template #message-danger>
                        {{ errors && errors.address_2 ? errors.address_2 : "" }}
                      </template>
                    </vs-input>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <vs-button color="#6c5dd4" class="float-end px-3" dark @click="e1 = 2">
              Continue
            </vs-button>
            <v-btn  text class="mt-1 float-end" to='/companies'>Cancel</v-btn>
          </v-stepper-content>

          <v-stepper-content step="2" class="py-2 px-1">
            <v-card class="mb-12" elevation="0" >
              <v-card-text>
                <v-row>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="">Select City</label>
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      dense
                      solo
                      label="Select your city"
                      v-model="Editform.city"
                      :items="Cities"
                      :error-messages="errors.city"
                    ></v-autocomplete>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="">Select State</label>
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      dense
                      solo
                      label="Select your state"
                      v-model="Editform.state"
                      :items="States"
                      :error-messages="errors.state"
                    ></v-autocomplete>
                  </v-col>
                  <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
                    <label for="">Select Pincode</label>
                    <v-autocomplete
                      class="role-autocomplete"
                      elevation="0"
                      dense
                      solo
                      label="Select your Pincode"
                      v-model="Editform.pincode"
                      :items="Pincodes"
                      :error-messages="errors.pincode"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <span class="text-h6 mx-3">Add Logo</span>
                  </v-col>
                  <v-col sm="6">
                    <b>Logo <span class="error--text">*</span></b>
                    <br />
                    <input
                      type="file"
                      id="file_1"
                      name="file_1"
                      ref="file_1"
                      accept="image/*"
                    />
                    <template v-if="Editform.logo_path != null">
                      <v-img
                        class="mt-2"
                        v-if="Editform.logo_path != null"
                        :src="mediaUrl + Editform.logo_path"
                        alt="image 1"
                        style="height: 50%; width: 50% !important"
                      />
                      <br />
                      <v-btn
                        x-small
                        class="mx-2"
                        :href="`${mediaUrl}${Editform.logo_path}`"
                        target="_blank"
                        color="#6c5dd4"
                        >View</v-btn
                      >
                      <v-btn
                        x-small
                        class="reset_image my-1"
                        color="red"
                        dark
                        @click="
                          ($refs.file_1.value = null),
                            (Editform.logo_path = null)
                        "
                        >Remove</v-btn
                      >
                    </template>
                  </v-col>
                  <v-col
                    lg="6"
                    xl="6"
                    md="6"
                    sm="12"
                    cols="12"
                    class="px-1 d-flex align-center mt-4"
                  >
                    <label for="" class="text-caption">Is Active</label>
                    <v-col lg="2" xl="2" md="2" sm="3" cols="3">
                      <vs-switch color="#6c5dd4" v-model="Editform.is_active">
                        <template #off> No </template>
                        <template #on> Yes </template>
                      </vs-switch>
                    </v-col>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <vs-button
              color="#6c5dd4"
              elevation="0"
              class="float-end px-3"
              dark
              :loading="isLoading"
              @click="update"
            >
              Update
            </vs-button>

            <v-btn text @click="e1 = 1" class="mt-1 float-end"> previous </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "CompanyEditPage",
  data() {
    return {
      Editform: {
        name: "",
      },
      isLoading: false,
      Cities: [],
      States: [],
      Pincodes: [],
      e1:1,
    };
  },
  mounted() {
    this.getMasters();
    this.getData();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("companies/masters");
      masters = masters.data;
      masters.cities.forEach((city) => {
        this.Cities.push({
          id: city.id,
          text: city.description,
          value: city.description,
        });
      });
      masters.states.forEach((state) => {
        this.States.push({
          id: state.id,
          text: state.description,
          value: state.description,
        });
      });
      masters.pincodes.forEach((pin) => {
        this.Pincodes.push({
          id: pin.id,
          text: pin.description,
          value: parseInt(pin.description),
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let companies = await axios.get(`/companies/${this.$route.params.companyId}`);
      this.Editform = companies.data.data;
      this.Editform.is_active = this.Editform.is_active ? true : false;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        let response = await axios.patch(
          `/companies/${this.$route.params.companyId}`,
          this.Editform
        );
        this.Editform = response.data.data;
        await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/companies");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.isLoading = true;
      const companyId = this.Editform.id;
      let formData = new FormData();
      formData.append("id", companyId);
      let logo_path = this.$refs.file_1?.files[0];
      formData.append("logo_path", logo_path);
      await axios
        .post("company_logo_upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
      this.isLoading = false;
    },
  },
};
</script>
